/**
 * User reducer
 */

import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const userReducer = (state = {}, action) => {
  let users;
  try {
    users = action.response.entities.users;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.EDIT_USER_PROFILE: {
      const { userId, name, email } = action;
      return _merge({}, state, { [userId]: { name, email } });
    }
    default: {
      if (users) {
        return _merge({}, state, users);
      }
      return state;
    }
  }
};

export default userReducer;
